var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "search-flex" }, [
        _c(
          "div",
          [
            _c("el-input", {
              staticClass: "search_input",
              attrs: { clearable: "", placeholder: "商品编号", size: "small" },
              model: {
                value: _vm.searchParams.goodsCode,
                callback: function ($$v) {
                  _vm.$set(_vm.searchParams, "goodsCode", $$v)
                },
                expression: "searchParams.goodsCode",
              },
            }),
            _c("el-input", {
              staticClass: "search_input",
              attrs: { clearable: "", placeholder: "商品名称", size: "small" },
              model: {
                value: _vm.searchParams.goodsName,
                callback: function ($$v) {
                  _vm.$set(_vm.searchParams, "goodsName", $$v)
                },
                expression: "searchParams.goodsName",
              },
            }),
            _c(
              "el-select",
              {
                staticClass: "search_input",
                attrs: {
                  clearable: "",
                  placeholder: "销售端类型",
                  size: "small",
                  multiple: "",
                  "collapse-tags": "",
                },
                model: {
                  value: _vm.searchParams.clientTypes,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchParams, "clientTypes", $$v)
                  },
                  expression: "searchParams.clientTypes",
                },
              },
              _vm._l(_vm.clientTypes.value, function (item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "search_input",
                attrs: {
                  clearable: "",
                  placeholder: "商品状态",
                  size: "small",
                },
                model: {
                  value: _vm.searchParams.state,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchParams, "state", $$v)
                  },
                  expression: "searchParams.state",
                },
              },
              [
                _c("el-option", { attrs: { label: "生效", value: "1" } }),
                _c("el-option", { attrs: { label: "失效", value: "0" } }),
              ],
              1
            ),
            _vm.currentTab.value === "local"
              ? _c(
                  "el-select",
                  {
                    staticClass: "search_input",
                    attrs: {
                      clearable: "",
                      placeholder: "审核状态",
                      size: "small",
                    },
                    model: {
                      value: _vm.searchParams.reviewStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchParams, "reviewStatus", $$v)
                      },
                      expression: "searchParams.reviewStatus",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "草稿", value: "1" } }),
                    _c("el-option", { attrs: { label: "待审核", value: "2" } }),
                    _c("el-option", {
                      attrs: { label: "审核通过", value: "3" },
                    }),
                    _c("el-option", {
                      attrs: { label: "审核不通过", value: "4" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "auth",
                    rawName: "v-auth",
                    value: "MEMBER_UNITE_SEARCH",
                    expression: "'MEMBER_UNITE_SEARCH'",
                  },
                ],
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.search },
              },
              [_vm._v("搜索")]
            ),
            _vm.currentTab.value === "local"
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "auth",
                        rawName: "v-auth",
                        value: "MEMBER_UNITE_ADD",
                        expression: "'MEMBER_UNITE_ADD'",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.add },
                  },
                  [_vm._v("新增")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("AddDialog", { ref: "addDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }